import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type OutrightsCouponIndexProps, OutrightsCouponWithQuery } from '@cx-modules/outrights-coupon';

export const OutrightsCoupon = (props: Omit<OutrightsCouponIndexProps, 'i18n'>) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <OutrightsCouponWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
